module.exports = __webpack_public_path__ + "static/media/CPCIndexLogo-white.f002d88b.png";